<template>
  <div class="overview-main">
    <div class="sys-title">微电网管控平台</div>
    <div class="main-content">
      <div class="div1">
        <div class="title">今日运行功率曲线</div>
        <div class="content" style="padding-top: 20px">
          <lineBarChart ref="jrgllinOpt" id="jrgllinOpt" :simpleOptions="jrgllinOpt" />
        </div>
      </div>
      <div class="div2">
        <div class="name">{{ currentPark.parkName }}</div>
        <div class="params">
          <div>
            <span>类型：</span>
            <span>
              {{
                currentPark.parkName !== "华自科技麓松路园区" && currentPark.parkName !== "尖山湖光储充场站"
                  ? "光储柴微电网"
                  : "光储充微电网"
              }}
            </span>
          </div>
          <div>
            <span>储能设备：</span>
            <span>{{ parkTip.tip }}中</span>
          </div>
          <div>
            <span>运行模式：</span>
            <span>削峰填谷</span>
          </div>
        </div>
        <div class="map-box">
          <mapChart ref="mapChart" id="mapChart" :option="mapOpt" />
        </div>
        <div class="params">
          <div>
            <span>光伏功率：</span>
            <span>{{ parkTip.genActual }}kW</span>
          </div>
          <div>
            <span>储能功率：</span>
            <span>{{ parkTip.storageActual }}kW</span>
          </div>
        </div>
      </div>
      <div class="div3">
        <div class="title">近30日收益统计</div>
        <div class="content" style="padding-top: 20px">
          <div class="chart-box">
            <lineBarChart ref="jysyllinOpt" id="jysyllinOpt" :simpleOptions="jysyllinOpt" />
          </div>
          <div class="other-box">
            <div class="block">
              <img src="/images/收益.png" />
              <div>
                <div class="lab">近一年收益</div>
                <div class="val yellow">
                  {{ totalData.totalIncome | miniValue }}
                  <span class="unit">{{ totalData.totalIncome | numUnit("元") }}</span>
                </div>
              </div>
            </div>
            <div class="block">
              <img src="/images/碳排放.png" />
              <div>
                <div class="lab">碳排放</div>
                <div class="val blue">
                  {{ totalData.carbonOut | miniValue }}
                  <span class="unit">{{ totalData.carbonOut | numUnit("吨") }}</span>
                </div>
              </div>
            </div>
            <img src="/images/约等于.png" />
            <div class="block">
              <img src="/images/树.png" />
              <div>
                <div class="lab">植树</div>
                <div class="val green">
                  {{ Math.ceil(totalData.treeCount) }}
                  <span class="unit">棵</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="div4">
        <div class="title">微电网收益排名</div>
        <div class="content">
          <div class="row" v-for="(item, index) in parkRanks" :key="item.name">
            <img :src="'/images/rank' + (index + 1) + '.png'" />
            <div class="name">{{ item.name }}</div>
            <div class="line"></div>
            <div class="value">
              {{ item.revenue }}
              <span class="unit">元</span>
            </div>
          </div>
        </div>
      </div>
      <div class="div5">
        <div class="title">近一年数据统计</div>
        <div class="content">
          <lineBarChart ref="linOpt" id="linOpt" :simpleOptions="linOpt" />
        </div>
      </div>
      <div class="div6">
        <div class="title">容量与电量</div>
        <div class="content">
          <div class="row pv">
            <div class="card">
              <img src="/images/光伏总容量.png" />
              <div>
                <div class="value">{{ chargeDisCharge.pvCapacity }}</div>
                <div class="label">光伏总容量(kW)</div>
              </div>
            </div>
            <div class="card">
              <img src="/images/光伏发电量.png" />
              <div>
                <div class="value">{{ chargeDisCharge.pvDischarging | miniValue1000 }}</div>
                <div class="label">光伏发电量({{ chargeDisCharge.pvDischarging | numUnit1000 }})</div>
              </div>
            </div>
          </div>
          <div class="row cn">
            <div class="card">
              <img src="/images/储能总容量.png" />
              <div>
                <div class="value">{{ chargeDisCharge.storageCapacity }}</div>
                <div class="label">储能总容量(kWh)</div>
              </div>
            </div>
            <div class="card">
              <img src="/images/累计充放电量.png" />
              <div>
                <div class="value">
                  {{ chargeDisCharge.storageCharging | miniValue1000 }}
                  /
                  {{ chargeDisCharge.storageDischarging | miniValue1000 }}
                </div>
                <div class="label">储能累计充/放电量({{ chargeDisCharge.storageCharging | numUnit1000 }})</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading v-show="loading" />
  </div>
</template>

<script>
import login from "@/mixins/login";
import park from "@/mixins/park";
import LineBarChart from "@/components/chart/lineBarChart.vue";
import mapChart from "@/components/chart/mapChart";
import {
  parkRank,
  chargingAndDischarging,
  yearTotal,
  eleAndIncome,
  eleAndIncomeByDate,
  carbonTotal,
  peakTip,
  todayGenAndStoPower,
  dayGenAndStoEarn,
} from "@/api/overview";
import loading from "@/components/loading";

function getFiveMinuteIntervals() {
  const intervals = [];
  const now = new Date();
  const startOfDay = new Date(now);
  startOfDay.setHours(0, 0, 0, 0); // 设置时间为当天的0点

  while (startOfDay <= now) {
    const hours = startOfDay.getHours().toString().padStart(2, "0");
    const minutes = startOfDay.getMinutes().toString().padStart(2, "0");
    intervals.push(`${hours}:${minutes}:00`);
    startOfDay.setMinutes(startOfDay.getMinutes() + 5); // 增加5分钟
  }

  return intervals;
}

function getFiveMinuteIntervals2() {
  const intervals = [];
  const now = new Date();
  const startOfDay = new Date(now);
  startOfDay.setHours(0, 0, 0, 0); // 设置时间为当天的0点

  while (startOfDay <= now) {
    // const hours = startOfDay.getHours().toString().padStart(2, "0");
    // const minutes = startOfDay.getMinutes().toString().padStart(2, "0");
    intervals.push(0);
    startOfDay.setMinutes(startOfDay.getMinutes() + 5); // 增加5分钟
  }

  return intervals;
}

export default {
  name: "overview",
  mixins: [login, park],
  components: {
    LineBarChart,
    mapChart,
    loading,
  },
  data() {
    return {
      mapOpt: {
        roam: true,
        tooltip: {
          trigger: "item",
          formatter: "{b}",
        },
        series: [
          {
            type: "map",
            map: "world",
            zoom: 1.4,
            itemStyle: {
              areaColor: "#016BD1", // 地图区域颜色
              borderColor: "#028EF2", // 边界线颜色
              borderWidth: 1, // 边界线宽度
            },
            emphasis: {
              label: {
                show: false,
                textStyle: {
                  color: "#fff", // 鼠标悬停时文字的颜色
                },
              },
              itemStyle: {
                areaColor: "#B3E5FF", // 鼠标悬停时城市的颜色
              },
            },
            markPoint: {
              symbol: `image://${location.protocol}//${location.host}/images/mapMark.png`,
              symbolSize: 18, // 图钉的大小
              itemStyle: {
                color: "#63FFC9", // 图钉的颜色
                borderColor: "rgba(99, 205, 201, 0.6)",
                borderWidth: 5,
              },
              data: [
                // {name: "标记点1", coord: [112.982279, 28.19409]}, // 湖南省长沙市的经纬度
              ],
            },
          },
        ],
      },
      parkRanks: [],
      yearTotalData: [],
      eleIncomeData: {},
      eleIncomeMData: {},
      chargeDisCharge: {},
      totalData: {},
      parkTip: {},
      todayGenStoPower: {
        genList: [],
        stoList: [],
      },
      dayGenAndStoIncome: {
        generationDeviceDataDays: [],
        generationDeviceDataMonths: [],
        storageDeviceDataDays: [],
      },
    };
  },
  computed: {
    linOpt() {
      return {
        legend: {
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
          data: ["用电量", "发电量"],
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#747E94FF",
            },
          },
          axisLabel: {
            color: "#fff",
            fontSize: 16,
          },
          data: this.yearTotalData.map((x) => x.mouth),
        },
        yAxis: {
          type: "value",
          name: "电量(kWh)",
          axisLine: {
            show: false,
          },
          nameTextStyle: {
            color: "#BFC8DB",
            fontSize: 16,
          },
          axisLabel: {
            color: "#BFC8DB",
            fontSize: 16,
          },
          splitLine: {
            lineStyle: {
              color: "#747E94",
            },
          },
        },
        series: [
          {
            name: "用电量",
            data: this.yearTotalData.map((x) => x.out),
            type: "line",
            smooth: true,
            showSymbol: false,
            itemStyle: {
              color: "#00EEFF",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00EEFF", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", //   0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          {
            name: "发电量",
            data: this.yearTotalData.map((x) => x.in),
            type: "line",
            smooth: true,
            showSymbol: false,
            itemStyle: {
              color: "#00FF8C",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#00FF8C", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", //   0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
    },
    jrgllinOpt() {
      return {
        legend: {
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
          data: ["光伏", "储能"],
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#747E94FF",
            },
          },
          axisLabel: {
            color: "#fff",
            fontSize: 16,
          },
          data: (() => {
            if (this.todayGenStoPower.genList.length) {
              return this.todayGenStoPower.genList.map((x) => x.ts);
            } else {
              return getFiveMinuteIntervals();
            }
          })(),
        },
        yAxis: {
          type: "value",
          name: "功率(kW)",
          axisLine: {
            show: false,
          },
          nameTextStyle: {
            color: "#BFC8DB",
            fontSize: 16,
          },
          axisLabel: {
            color: "#BFC8DB",
            fontSize: 16,
          },
          splitLine: {
            lineStyle: {
              color: "#747E94",
            },
          },
        },
        series: [
          {
            name: "光伏",
            data: (() => {
              if (this.todayGenStoPower.genList && this.todayGenStoPower.genList.length) {
                return this.todayGenStoPower.genList.map((x) => x.total_active_power);
              } else {
                return getFiveMinuteIntervals2();
              }
            })(),
            type: "line",
            smooth: true,
            showSymbol: false,
            itemStyle: {
              color: "#00FF8C",
            },
          },
          {
            name: "储能",
            data: (() => {
              if (this.todayGenStoPower.stoList && this.todayGenStoPower.stoList.length) {
                return this.todayGenStoPower.stoList.map((x) => x.total_active_power);
              } else {
                return getFiveMinuteIntervals2();
              }
            })(),
            type: "line",
            smooth: true,
            showSymbol: false,
            itemStyle: {
              color: "#00EEFF",
            },
          },
        ],
      };
    },
    jysyllinOpt() {
      return {
        legend: {
          itemWidth: 14,
          itemHeight: 14,
          icon: "rect",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
          data: ["光伏", "储能"],
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#747E94FF",
            },
          },
          axisLabel: {
            color: "#fff",
            fontSize: 16,
          },
          data: this.dayGenAndStoIncome.generationDeviceDataMonths,
        },
        yAxis: {
          type: "value",
          name: "收益(元)",
          axisLine: {
            show: false,
          },
          nameTextStyle: {
            color: "#BFC8DB",
            fontSize: 16,
          },
          axisLabel: {
            color: "#BFC8DB",
            fontSize: 16,
          },
          splitLine: {
            lineStyle: {
              color: "#747E94",
            },
          },
        },
        series: [
          {
            name: "光伏",
            data: this.dayGenAndStoIncome.generationDeviceDataDays,
            type: "bar",
            smooth: true,
            showSymbol: false,
            stack: "Ad",
            itemStyle: {
              color: "#00FF8C",
            },
          },
          {
            name: "储能",
            data: this.dayGenAndStoIncome.storageDeviceDataDays,
            type: "bar",
            smooth: true,
            showSymbol: false,
            stack: "Ad",
            itemStyle: {
              color: "#00EEFF",
            },
          },
        ],
      };
    },
    pie1Opt() {
      return {
        color: ["#699BFF", "#00EEFF", "#00FF8C"],
        title: {
          text: "上月电量",
          left: "center",
          top: "40%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "center",
          top: "bottom",
          itemGap: 68,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "pie",
            top: -10,
            radius: ["50%", "65%"],
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [
              {value: this.eleIncomeData.genEle, name: "光伏发电量"},
              {value: this.eleIncomeData.storageInEle, name: "储能总充电量"},
              {value: this.eleIncomeData.storageOutEle, name: "储能总放电量"},
            ],
          },
        ],
      };
    },
    pie2Opt() {
      return {
        color: ["#699BFF", "#00EEFF", "#00FF8C"],
        title: {
          text: "当月电量",
          left: "center",
          top: "40%",
          textStyle: {
            fontSize: 16,
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "center",
          top: "bottom",
          itemGap: 68,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "pie",
            top: -10,
            radius: ["50%", "65%"],
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: [
              {value: this.eleIncomeMData.genEle, name: "光伏发电量"},
              {value: this.eleIncomeMData.storageInEle, name: "储能总充电量"},
              {value: this.eleIncomeMData.storageOutEle, name: "储能总放电量"},
            ],
          },
        ],
      };
    },
  },
  mounted() {
    this.setFontSize();
    window.addEventListener("resize", this.setFontSize);
  },
  methods: {
    setFontSize() {
      const screenWidth =
        document.querySelector(".overview-main") && document.querySelector(".overview-main").offsetWidth;
      const fontSize = (14 * screenWidth) / 1920;
      document.documentElement.style.fontSize = fontSize + "px";
    },
    getData() {
      this.getParkList("center");
      this.getParkRank();
    },
    // 电站功率
    getPeakTip() {
      peakTip({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.parkTip = res.data.data;
      });
    },
    // 收益和碳排放
    getCarbonTotal() {
      carbonTotal({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.totalData = res.data.data;
      });
    },
    // 微电网收益排名
    getParkRank() {
      parkRank().then((res) => {
        this.parkRanks = res.data.data;
      });
    },
    // 右下角容量与电量
    getChargingAndDischarging() {
      chargingAndDischarging({
        parkId: this.currentPark.parkId,
      }).then((res) => {
        this.chargeDisCharge = res.data.data;
      });
    },
    // 上月电量与收益统计
    getEleAndIncome() {
      eleAndIncome({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.eleIncomeData = res.data.data;
        this.$nextTick(() => {
          this.$refs.pie1.updateChart();
        });
      });
    },
    // 当月电量与收益统计
    getEleAndIncomeByDate() {
      eleAndIncomeByDate({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.eleIncomeMData = res.data.data;
        this.$nextTick(() => {
          this.$refs.pie2.updateChart();
        });
      });
    },
    // 今日运行功率曲线
    getTodayGenAndStoPower() {
      todayGenAndStoPower({
        parkId: this.currentPark.parkId,
      }).then((res) => {
        this.todayGenStoPower = res.data.data;
        this.$nextTick(() => {
          this.$refs.jrgllinOpt.updateChart();
        });
      });
    },
    // 近30日收益统计
    getDayGenAndStoEarn() {
      dayGenAndStoEarn({
        parkId: this.currentPark.parkId,
      }).then((res) => {
        this.dayGenAndStoIncome = res.data.data;
        this.$nextTick(() => {
          this.$refs.jysyllinOpt.updateChart();
        });
      });
    },
    // 近一年数据统计
    getYearTotal() {
      yearTotal({
        parkId: this.currentPark.parkId,
        coefficient: this.currentPark.coefficient,
      }).then((res) => {
        this.yearTotalData = res.data.data;
        this.$nextTick(() => {
          this.$refs.linOpt.updateChart();
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/tools";

.overview-main {
  background: url("../assets/images/bg.png");
  background-size: 100% 100%;
  height: 1080px;
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
  color: #fff;
  .sys-title {
    height: 96px;
    line-height: 96px;
    text-align: center;
    font-size: 36px;
    background: url("../assets/images/sysTitbg.png");
    background-size: 100% 100%;
  }
  .main-content {
    flex: 1;
    display: grid;
    grid-template-columns: 480px 1fr 480px;
    grid-template-rows: 512px 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 70px;
    padding: 40px;
    .div1 {
      grid-area: 1 / 1 / 2 / 2;
    }
    .div2 {
      grid-area: 1 / 2 / 2 / 3;
    }
    .div3 {
      grid-area: 1 / 3 / 2 / 4;
    }
    .div4 {
      grid-area: 2 / 1 / 3 / 2;
    }
    .div5 {
      grid-area: 2 / 2 / 3 / 3;
      & > .title {
        background: url("../assets/images/fhTitleL.png");
        background-size: 100% 100%;
      }
    }
    .div6 {
      grid-area: 2 / 3 / 3 / 4;
    }
    & > div {
      display: flex;
      flex-direction: column;
      & > .title {
        background: url("../assets/images/fhTitle.png");
        background-size: 100% 100%;
        height: 36px;
        line-height: 36px;
        font-size: 20px;
        padding-left: 40px;
      }
      & > .content {
        flex: 1;
      }
    }
    .div1,
    .div3 {
      & > .content {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        .chart-box {
          flex: 1;
        }
        .chart-value {
          display: flex;
          justify-content: space-between;
          padding: 0 8px;
          font-size: 30px;
          font-weight: bold;
          & > div:nth-child(1) {
            color: #699bff;
          }
          & > div:nth-child(2) {
            color: #00eeff;
          }
          & > div:nth-child(3) {
            color: #00ff8c;
          }
          .unit {
            font-size: 14px;
            font-weight: normal;
          }
        }
        .income-box {
          margin-top: 28px;
          .row {
            display: flex;
            align-items: center;
            & + .row {
              margin-top: 18px;
            }
            .label {
              font-size: 18px;
            }
            .line {
              flex: 1;
              height: 4px;
              border-radius: 2px;
              margin: 0 15px;
              &.blue {
                background: rgba(105, 155, 255, 0.38);
              }
              &.cyan {
                background: rgba(0, 238, 255, 0.38);
              }
              &.green {
                background: rgba(0, 255, 140, 0.38);
              }
            }
            .value {
              font-size: 20px;
              font-weight: bold;
              &.blue {
                color: rgb(105, 155, 255);
              }
              &.cyan {
                color: rgb(0, 238, 255);
              }
              &.green {
                color: rgb(0, 255, 140);
              }
              span {
                font-weight: normal;
                font-size: 18px;
              }
            }
          }
        }
        .other-box {
          display: flex;
          align-items: center;
          margin-top: 30px;
          .rainbow-box {
            position: relative;
            flex: 1;
            margin-left: 16px;
            display: flex;
            justify-content: space-between;
            .line {
              position: absolute;
              top: 50%;
              left: 0;
              width: 100%;
              height: 2px;
              border-radius: 2px;
              background: linear-gradient(
                90deg,
                rgba(105, 155, 255, 1) 11.57%,
                rgba(0, 238, 255, 1) 37.74%,
                rgba(0, 255, 140, 1) 64.35%,
                rgba(255, 255, 0, 1) 89.36%
              );
            }
            .item {
              display: flex;
              flex-direction: column;
              align-items: center;
              &.blue {
                color: rgb(105, 155, 255);
              }
              &.cyan {
                color: rgb(0, 238, 255);
              }
              &.green {
                color: rgb(0, 255, 140);
              }
              &.yellow {
                color: rgb(255, 255, 0);
              }
              i {
                font-size: 18px;
              }
              .lab {
                font-size: 14px;
                line-height: 22px;
                margin-top: 2px;
                color: #fff;
              }
              .val {
                font-size: 18px;
                font-weight: bold;
                margin-top: 16px;
              }
            }
          }
          & > .block {
            display: flex;
            &:nth-child(1) {
              margin-right: auto;
            }
            img {
              margin-right: 10px;
              width: 50px;
              height: 50px;
            }
            .lab {
              font-size: 14px;
            }
            .val {
              font-size: 20px;
              font-weight: 600;
              &.yellow {
                background: linear-gradient(to bottom, #ffffff, #ffde59);
                -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
                -webkit-text-fill-color: transparent; /*给文字设置成透明*/
              }
              &.blue {
                background: linear-gradient(to bottom, #ffffff, #30ddff);
                -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
                -webkit-text-fill-color: transparent; /*给文字设置成透明*/
              }
              &.green {
                background: linear-gradient(to bottom, #ffffff, #24ffbd);
                -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
                -webkit-text-fill-color: transparent; /*给文字设置成透明*/
              }
            }
            .unit {
              font-size: 14px;
            }
          }
        }
      }
    }
    .div2 {
      display: flex;
      flex-direction: column;
      align-items: center;
      .name {
        width: 379px;
        height: 39px;
        line-height: 39px;
        background: url("../assets/images/nameBg.png");
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
      }
      .params {
        display: flex;
        justify-content: center;
        margin-top: 34px;
        & > div {
          width: 216px;
          height: 40px;
          line-height: 40px;
          background: url("../assets/images/pmbg.png");
          background-size: 100% 100%;
          text-align: center;
          font-size: 18px;
          & > span:last-child {
            color: #00eeff;
          }
          & + div {
            margin-left: 40px;
          }
        }
      }
      .map-box {
        flex: 1;
        width: 100%;
      }
    }
    .div4 > .content {
      display: flex;
      flex-direction: column;
      padding: 22px 20px;
      .row {
        display: flex;
        align-items: center;
        & + .row {
          margin-top: 22px;
        }
        img {
          margin-right: 15px;
        }
        .name {
          font-size: 18px;
        }
        .line {
          flex: 1;
          height: 1px;
          border-top: 1px dashed #003c85;
          margin: 0 15px;
        }
        .value {
          font-size: 20px;
          font-weight: bold;
          .unit {
            font-size: 14px;
          }
        }
      }
    }
    .div6 > .content {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      .row {
        display: flex;
        &.pv {
          height: 98px;
          & > .card {
            flex: 1;
          }
        }
        &.cn {
          flex: 1;
          margin-top: 16px;
          & > .card:first-child {
            width: 198px;
          }
          & > .card:last-child {
            flex: 1;
          }
          .card {
            flex-direction: column;
            align-items: center;
            .value {
              text-align: center;
            }
          }
        }
        .card {
          background: linear-gradient(90deg, #0c2158 0%, #021644 100%);
          border: 1px solid #003a7d;
          display: flex;
          align-items: center;
          img {
            width: 62px;
            margin-left: 10px;
          }
          .value {
            color: #00eeff;
            font-size: 24px;
            font-weight: bold;
          }
          .label {
            font-size: 18px;
          }
          & + .card {
            margin-left: 16px;
          }
        }
      }
    }
  }
}
</style>
